import { Drawer } from "@heroui/react";
import RecordingDetailsComp from "../recordings/recording-details-comp";

const RecordingDetailsDrawer = ({ state, _recording_id, record, refreshKey, onDeleted }) => {
  return (
    <Drawer state={state}>
      <Drawer.Backdrop variant="blur" className="bg-black/30">
        <Drawer.Content placement="right">
          <Drawer.Dialog className={"w-full sm:min-w-[500px]"}>
            <Drawer.Body className="overflow-y-auto">
              <RecordingDetailsComp _recording_id={_recording_id} record={record} refreshKey={refreshKey} onDeleted={onDeleted} onClose={() => state.close()} />
            </Drawer.Body>
          </Drawer.Dialog>
        </Drawer.Content>
      </Drawer.Backdrop>
    </Drawer>
  );
};

export default RecordingDetailsDrawer;